export default __webpack_public_path__ + "static/media/TOdolist.8d83493e.png";